import CompletionBar from './CompletionBar';

export default CompletionBar;
